const fakeAuthProvider = {
  isAuthenticated: localStorage.getItem('auth') || false,
  signin(callback) {
    localStorage.setItem('auth', true);
    fakeAuthProvider.isAuthenticated = true;
    setTimeout(callback, 100);
  },
  signout(callback) {
    fakeAuthProvider.isAuthenticated = false;
    callback();
  },
};

export { fakeAuthProvider };
